(() => {
  const config = document.getElementById('nook-product-accessibility-labels');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const scopeSelector = '#zapio-block-fbt, .jdgm-widget, .jdgm-write-review-modal, .jm-carousel, .jdgm-write-review-modal__btn--back';
  const backSelector = 'a.jdgm-write-review-modal__btn--back:not([href])';

  const elements = (root, selector) => [
    ...(root.matches(selector) ? [root] : []),
    ...root.querySelectorAll(selector),
  ];
  const setAttribute = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };

  const patchZapio = (root) => {
    elements(root, 'input.zapio-checkbox-input').forEach((input) => {
      const card = input.closest('.zapio-fbt-product-card');
      const title = card?.querySelector('img[alt]')?.getAttribute('alt')?.trim() || labels.product;
      setAttribute(input, 'aria-label', labels.includeProduct.replace('__TITLE__', title));
    });
    elements(root, '.zapio-fbt-product-image > img').forEach((image) => {
      setAttribute(image, 'loading', 'lazy');
      setAttribute(image, 'decoding', 'async');
    });
  };

  const patchJudgeMe = (root) => {
    elements(root, backSelector).forEach((back) => {
      setAttribute(back, 'role', 'button');
      setAttribute(back, 'tabindex', '0');
    });
    elements(root, '.jm-carousel-review-item[role="button"][aria-label]').forEach((card) => {
      card.removeAttribute('aria-label');
    });
  };

  const initializedRoots = new WeakMap();
  const pending = new Set();
  let scheduled = false;

  const update = (state) => {
    state.observer.disconnect();
    if (!state.root.isConnected) return;
    try {
      patchZapio(state.root);
      patchJudgeMe(state.root);
    } finally {
      state.observer.observe(state.root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['aria-label', 'role', 'alt'],
      });
    }
  };

  const schedule = (state) => {
    pending.add(state);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const batch = [...pending];
      pending.clear();
      batch.forEach(update);
    });
  };

  const bind = (root) => {
    if (root.parentElement?.closest('[data-nook-product-a11y]')) return;
    const previous = initializedRoots.get(root);
    if (previous) {
      schedule(previous);
      return;
    }
    root.setAttribute('data-nook-product-a11y', '');
    const state = { root };
    state.observer = new MutationObserver(() => schedule(state));
    initializedRoots.set(root, state);
    update(state);
  };

  const discover = (node) => {
    if (node.nodeType !== 1) return;
    if (node.matches(scopeSelector)) bind(node);
    node.querySelectorAll(scopeSelector).forEach(bind);
  };

  const start = () => {
    document.querySelectorAll(scopeSelector).forEach(bind);
    const discovery = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.target.nodeType === 1 && record.target.closest('[data-nook-product-a11y]')) return;
        record.addedNodes.forEach(discover);
      });
    });
    discovery.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('keydown', (event) => {
    if (event.defaultPrevented || (event.key !== 'Enter' && event.key !== ' ')) return;
    const back = event.target.closest?.(backSelector);
    if (!back || back.getAttribute('role') !== 'button') return;
    event.preventDefault();
    back.click();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
